import { getTextBox } from './getSkills';
import latestReleases from '../helpers/versions/latestReleases';

/**
 * NOTE: When new version is introduced for a component,
 * overwrite the version for that component but retain for others
 */
export default ({ preTag, componentKey }) => {
  const documentData = {
    version: {
      number: latestReleases[componentKey],
      updated: true,
    },
  };
  let data = {
    toExport: false,
  };
  if (preTag === 'phone_number' || preTag === 'sender_phone_number') {
    data = {
      ...data,
      dialCode: '1',
      countryCode: 'us',
      name: 'United States',
    };
  }

  return {
    document: {
      data: { ...documentData },
      nodes: [
        {
          object: 'block',
          type: preTag,
          data,
          nodes: [getTextBox()],
        },
      ],
    },
  };
};
